<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->

      <page :url="url" :form="form">
        <template slot="tableSearch">
          <el-form-item label="渠道编号">
            <el-input
              style="width: 300px"
              v-model="form.channelId"
              placeholder="请输入渠道编号/渠道名称"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="收付类型"
            prop="productId"
            v-if="$store.state.roleId == '1070960390067716097'"
          >
            <el-select
              v-model="form.productId"
              placeholder="请选择收付类型"
              :disabled="$store.state.roleId == '2125410685723869666'"
            >
              <el-option key="" label="--请选择--" value=""></el-option>
              <el-option label="代收" value="110"></el-option>
              <el-option label="代付" value="120"></el-option>
            </el-select>
          </el-form-item>
        </template>

        <template slot="buttonArea">
          <el-button type="primary" @click="add" size="small"
            >添加渠道</el-button
          >
        </template>

        <template slot="tableColumn">
          <el-table-column
            prop="channelId"
            width="120px"
            label="渠道编号"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="productName"
            width="80px"
            label="渠道类型"
            align="center"
          >
            <template slot-scope="{ row }">
              <div>{{ row.productId == 110 ? '代收' : '代付' }}</div>
            </template>
          </el-table-column>

          <el-table-column 
          prop="channelName" 
          width="150px"
          label="渠道名称" 
          align="center"
          >
          </el-table-column>

          <el-table-column
            prop="channelStatus"
            :formatter="$formatter.formatMerState"
            width="80px"
            label="交易状态"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="priority"
            width="100px"
            label="优先级"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="minAmount"
            width="120px"
            label="最小交易金额"
            align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.minAmount">
                {{ $formatter.FenToYuan(null, null, row.minAmount, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
            prop="maxAmount"
            width="120px"
            label="最大交易金额"
            align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.maxAmount">
                {{ $formatter.FenToYuan(null, null, row.maxAmount, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column prop="rate" label="费率" width="80px" align="center">
          </el-table-column>

          <el-table-column
            prop="updateTime"
            label="修改时间"
            width="150px"
            align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.updateTime">
                {{ $formatter.formatDate(null, null, row.updateTime, null) }}
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column
            prop="updateUser"
            label="修改人"
            width="130px"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="createTime"
            label="创建时间"
            :formatter="$formatter.formatDate"
            width="160px"
            align="center"
          >
          </el-table-column>

          <el-table-column
            fixed="right"
            label="操作"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                plain
                @click="edit(scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </template>
      </page>

      <!--<DeviceAdd :show.sync="showDialog" :formData="formData" :action="action"></DeviceAdd>-->
      <!--<DevicePayType :show.sync="showSetPayDialog" :formData="formData" :action="action"></DevicePayType>-->

      <RouteChannelInfoEdit
        :show.sync="showDialog"
        :value="formData"
        :action="action"
        :channel-option="channelOption"
      ></RouteChannelInfoEdit>
    </div>
  </div>
</template>

<script>
import Page from '@/components/Page.vue'
import RouteChannelInfoEdit from './RouteChannelInfoEdit'

export default {
  name: 'Systems',
  components: {
    page: Page,
    RouteChannelInfoEdit: RouteChannelInfoEdit,
  },
  data() {
    return {
      url: '/routeChannelInfo/selectList',
      action: '',
      form: {
        channelId: '',
        productId: '',
      },
      deviceToken: '',
      showDialog: false,
      formData: null,
      showSetPayDialog: false,
      channelOption: [],
    }
  },
  created() {
    // this.$axios
    //   .get("/productType/selectByProductType", { params: {} })
    //   .then((res) => {
    //     this.channelOption = res.data;
    //   });
  },
  methods: {
    edit(row) {
      this.action = 'edit'
      this.formData = row
      this.showDialog = true
    },
    add() {
      this.action = 'add'
      this.showDialog = true
    },
  },
}
</script>

<style scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>